import {
  blue,
  blueHover,
  orange,
  graySecondaryDark,
  grayDividerSecondary,
  grayDividerLighter,
  grayDisabled,
  orangeLight,
  grayLight,
  red,
  white,
  transparent,
  orangeHover,
  blueSecondaryLight,
  grayInformativeText,
  orangeDark,
  bluePrimaryLight,
  graySecondary,
} from './colors';

const buttonTheme = {
  buttonBgColor: transparent,
  buttonBgColorLight: white,
  buttonBgColorInverse: blue,
  buttonBgColorInverseLight: blueSecondaryLight,
  buttonBgHover: blueHover,
  buttonBgDisabled: grayDisabled,
  buttonTextColor: blue,
  buttonTextColorInverse: white,
  buttonTextColorHoverInverse: graySecondaryDark,
  buttonTextColorHover: blueHover,
  buttonTextColorDisabled: white,
  buttonBorderColor: blue,
  buttonBorderHoverColor: blueHover,
  buttonBorderColorDisabled: white,
  buttonArrowColor: blue,
  buttonArrowColorInverse: white,
  buttonIconColor: orange,
  buttonIconColorInverse: graySecondaryDark,
  buttonIconColorHover: orangeHover,
};

const modalTheme = {
  modalBgColor: white,
  modalTitleColor: graySecondaryDark,
};

const inputTheme = {
  inputArrowColor: blue,
  validInputBorder: grayLight,
  inputTextColor: blue,
};
const placeholderTheme = {
  placeholderColor: blue,
  placeholderActiveColor: graySecondaryDark,
  placeholderDisabledColor: graySecondary,
};
const BannerTheme = {
  bannerTextColor: white,
  bannerBorderColor: orangeDark,
  bannerBgColor: orangeHover,
  inlineBannerBgColor: orangeHover,
};

const selectTheme = {
  selectTextColor: blue,
};

const chatTheme = {
  chatBgColor: orange,
  chatTextColor: white,
};

export const themes = {
  default: {
    ...buttonTheme,
    ...modalTheme,
    ...BannerTheme,
    ...inputTheme,
    ...selectTheme,
    ...chatTheme,
    ...placeholderTheme,
    colorText: graySecondaryDark,
    smallPrintColor: grayInformativeText,
    bgColor: grayDividerLighter,
    invalidColor: red,
    dividerColor: grayDividerSecondary,
    radioIconColor: blue,
  },
  prevTheme: {
    primaryColor: blue,
    icon: 'prev',
  },
  capTheme: {
    primaryColor: orange,
    secondaryColor: orangeLight,
    hoverColor: orangeHover,
    borderColor: grayDividerLighter,
    divider: grayDividerSecondary,
    icon: 'cap',
  },
  ibcTheme: {
    primaryColor: bluePrimaryLight,
    secondaryColor: bluePrimaryLight,
    bannerBorderColor: bluePrimaryLight,
    inlineBannerBgColor: bluePrimaryLight,
  },
};
